import React, { useState, useEffect } from "react";
import DataTable from "../AllComponents/DataTable";
import LoadingSkeleton from "../AllComponents/LoadingSkeleton";
import axios from "axios";
import "./Users.css";

function Users() {
  const [userData, setUserData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const tableHeaders = ["Id", "Name", "Email", "Phone", "DOB"];

  useEffect(() => {
    axios
      .get("https://resto-app-user.herokuapp.com/user/get-all-users-for-admin")
      .then(function (response) {
        setUserData(response.data.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, []);

  console.log(userData);

  return (
    <div className="user-screen">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          margin: "20px 20px 0px",
        }}
      >
        <p>Total Users : {userData.length}</p>
        <div className="table-header-right">
          <button
            className="table-header-btn btn__"
            style={{ border: "1px solid #EF3340", color: "#EF3340" }}
          >
            Export to Excel
          </button>
          <div className="table-header-input input">
            <div>
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M9.16663 3.33317C5.94496 3.33317 3.33329 5.94484 3.33329 9.1665C3.33329 12.3882 5.94496 14.9998 9.16663 14.9998C12.3883 14.9998 15 12.3882 15 9.1665C15 5.94484 12.3883 3.33317 9.16663 3.33317ZM1.66663 9.1665C1.66663 5.02437 5.02449 1.6665 9.16663 1.6665C13.3088 1.6665 16.6666 5.02437 16.6666 9.1665C16.6666 13.3086 13.3088 16.6665 9.16663 16.6665C5.02449 16.6665 1.66663 13.3086 1.66663 9.1665Z"
                  fill="#39424E"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M13.2857 13.2856C13.6111 12.9601 14.1388 12.9601 14.4642 13.2856L18.0892 16.9106C18.4147 17.236 18.4147 17.7637 18.0892 18.0891C17.7638 18.4145 17.2361 18.4145 16.9107 18.0891L13.2857 14.4641C12.9603 14.1387 12.9603 13.611 13.2857 13.2856Z"
                  fill="#39424E"
                />
              </svg>
            </div>
            <input
              type="text"
              placeholder="Search Users"
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>
      </div>
      <div style={{ padding: "20px" }}>
        {userData.length === 0 ? (
          <LoadingSkeleton />
        ) : (
          <DataTable
            tableHeaders={tableHeaders}
            tableData={userData}
            searchData={searchTerm}
          />
        )}
      </div>
    </div>
  );
}

export default Users;
